import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Canonical "back" navigation link — the ArrowLeft + label pattern that repeats at the top of ~8
 * secondary pages (Account, Wallet, Guides, Pricing, …). One component so the affordance is
 * identical everywhere.
 */
export interface BackLinkProps {
  to: string;
  label?: string;
  className?: string;
}

export const BackLink: React.FC<BackLinkProps> = ({ to, label = 'Back', className }) => (
  <Link
    to={to}
    className={cn('inline-flex items-center gap-1.5 text-sm text-secondary-500 hover:text-secondary-800 dark:hover:text-secondary-200 transition-colors', className)}
  >
    <ArrowLeft className="w-4 h-4" /> {label}
  </Link>
);

export default BackLink;
